export enum RDateDirection {
  End = 'end',
  Start = 'start',
}

export interface RDateProps {
  direction: RDateDirection
  label: string
  date: string
  time?: string
  format?: string
  link?: string
}
